// removed by extract-text-webpack-plugin
module.exports = {"card":"ck_cl","header":"ck_bg","tagContainer":"ck_cm","tag":"ck_cn","redTag":"ck_co ck_cn","gradient":"ck_cp","info":"ck_cb","imageContainer":"ck_cq","image":"ck_l","title":"ck_n","titleLink":"ck_cr","details":"ck_cs","strapline":"ck_ct","location":"ck_cu","time":"ck_cv","carousel":"ck_cw","link":"ck_cx","priceRange":"ck_cy","rating":"ck_cz","totalReviews":"ck_c0","saveEventContainer":"ck_c1","heart":"ck_c2"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventCard/styles.module.css
// module id = 1152
// module chunks = 27